import { createUseStyles } from 'react-jss'
import { THEME } from 'components/theme'

// Variant A — "flyout card": the Report rail item opens a menu card to its right
// that springs in, with the Customer/Supplier choices rising in sequence.
export const ReportTabStyles = createUseStyles({
  '@keyframes reportFlyoutIn': {
    from: { opacity: 0, transform: 'translateX(-10px) scale(0.96)' },
    to: { opacity: 1, transform: 'translateX(0) scale(1)' }
  },
  '@keyframes reportOptRise': {
    from: { opacity: 0, transform: 'translateY(8px)' },
    to: { opacity: 1, transform: 'translateY(0)' }
  },
  // Dims + slightly blurs the page and catches the outside click that closes the menu.
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 3000,
    background: 'rgba(24, 40, 30, 0.10)',
    backdropFilter: 'blur(1.5px)'
  },
  flyout: {
    position: 'fixed',
    zIndex: 3001,
    width: 200,
    background: THEME.brandWhite,
    border: `1px solid ${THEME.brandLightGrey}`,
    borderRadius: 16,
    padding: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    boxShadow: '0 18px 44px rgba(20, 40, 30, 0.20)',
    transformOrigin: 'left center',
    animationName: '$reportFlyoutIn',
    animationDuration: '0.34s',
    animationTimingFunction: 'cubic-bezier(.34, 1.56, .64, 1)',
    animationFillMode: 'both'
  },
  flyoutTitle: {
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '0.04em',
    color: THEME.infoGrey,
    textTransform: 'uppercase',
    padding: '4px 8px 2px'
  },
  opt: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '9px 12px',
    borderRadius: 12,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 14,
    color: THEME.brandBlack,
    background: THEME.brandWhite,
    border: `1px solid ${THEME.brandLightGrey}`,
    textAlign: 'left',
    width: '100%',
    animationName: '$reportOptRise',
    animationDuration: '0.4s',
    animationTimingFunction: 'cubic-bezier(.22, 1, .36, 1)',
    animationFillMode: 'both',
    transition: 'border-color 0.16s, background 0.16s, transform 0.16s',
    '&:hover': {
      borderColor: THEME.brandGreen,
      background: THEME.brandLightestGrey,
      transform: 'translateX(2px)'
    },
    // Children are [title, customer, supplier] — stagger the two options.
    '&:nth-child(2)': { animationDelay: '0.06s' },
    '&:nth-child(3)': { animationDelay: '0.13s' }
  },
  optDot: {
    width: 26,
    height: 26,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      width: 22,
      height: 22,
      fill: 'currentColor',
      stroke: 'none'
    },
    '& img': {
      width: 22,
      height: 22,
      objectFit: 'contain',
      // The truck asset ships near-black; lift it to a neutral gray to match the person glyph.
      filter: 'invert(42%)'
    }
  },
  custDot: { color: THEME.infoGrey },
  suppDot: { color: THEME.infoGrey },
  // Full-screen overlay for the report itself (AccountReport fills height:100%).
  reportOverlay: {
    position: 'fixed',
    inset: 0,
    zIndex: 2000,
    background: THEME.brandWhite
  }
})
